import { addDoc, collection, getDocs, limit, orderBy, query, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { STUDIO_AI_SESSIONS_COLLECTION } from "../../constants";

const LOCAL_KEY = "firestoreStudio.ai.sessions";

function nowIso() {
  return new Date().toISOString();
}

function loadLocal() {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveLocal(list) {
  try {
    localStorage.setItem(LOCAL_KEY, JSON.stringify(list));
  } catch { /* quota */ }
}

export function listLocalSessions() {
  return loadLocal().sort((a, b) => {
    if (Boolean(b.pinned) !== Boolean(a.pinned)) return b.pinned ? 1 : -1;
    return (b.updatedAt || "").localeCompare(a.updatedAt || "");
  });
}

export function saveLocalSession(session) {
  const list = loadLocal();
  const record = {
    id: session.id || `chat_${Date.now()}`,
    title: session.title || "New chat",
    messages: session.messages || [],
    pinned: Boolean(session.pinned),
    createdAt: session.createdAt || nowIso(),
    updatedAt: nowIso(),
  };
  const idx = list.findIndex((s) => s.id === record.id);
  if (idx >= 0) list[idx] = { ...list[idx], ...record };
  else list.unshift(record);
  saveLocal(list.slice(0, 50));
  return record;
}

export function deleteLocalSession(id) {
  saveLocal(loadLocal().filter((s) => s.id !== id));
}

export function clearAllLocalSessions() {
  saveLocal([]);
}

export function togglePinSession(id) {
  saveLocal(loadLocal().map((s) => (s.id === id ? { ...s, pinned: !s.pinned } : s)));
}

export function searchSessions(term) {
  const q = String(term || "").toLowerCase();
  if (!q) return listLocalSessions();
  return listLocalSessions().filter((s) =>
    s.title.toLowerCase().includes(q)
    || (s.messages || []).some((m) => String(m.content || "").toLowerCase().includes(q))
  );
}

/** Persist session snapshot to Firestore (audit / backup). */
export async function persistSessionToFirestore(session, userUid) {
  const ref = await addDoc(collection(db, STUDIO_AI_SESSIONS_COLLECTION), {
    userUid: userUid || "",
    title: session.title || "Chat",
    messages: session.messages || [],
    pinned: Boolean(session.pinned),
    createdAt: session.createdAt || nowIso(),
    updatedAt: nowIso(),
  });
  return ref.id;
}

export async function listFirestoreSessions(userUid, max = 20) {
  const snap = await getDocs(
    query(collection(db, STUDIO_AI_SESSIONS_COLLECTION), orderBy("updatedAt", "desc"), limit(max))
  );
  return snap.docs.map((d) => ({ id: d.id, ...d.data() })).filter((s) => !userUid || s.userUid === userUid);
}

export async function updateFirestoreSession(id, patch) {
  await updateDoc(doc(db, STUDIO_AI_SESSIONS_COLLECTION, id), { ...patch, updatedAt: nowIso() });
}

export async function deleteFirestoreSession(id) {
  await deleteDoc(doc(db, STUDIO_AI_SESSIONS_COLLECTION, id));
}
